import BaseObject from '../../../base/base_object';
import GameSequenceBuilder from '../game_sequence_builder/game_sequence_builder';
import ServiceFactory from '../../service_factory';

export default class GameSequenceInitializerBase extends BaseObject {
    static CLASS = 'GameSequenceInitializerBase';
    protected serviceFactory: ServiceFactory;

    init(params) {
        if(!params.serviceFactory) {
            this.throwArgumentExpected('11', 'init', 'serviceFactory');
        }
        this.serviceFactory = params.serviceFactory;
    }

    initSequenceBuilder() {
        this.throwNotImplemented('17', 'initSequenceBuilder');
    }

    _createSequenceBuilder(): GameSequenceBuilder {
        return GameSequenceBuilder.create({
            serviceFactory: this.serviceFactory
        });
    }
}